import { C } from './constants';

/**
 * SVG radar/spider chart.
 * Renders a polygon over concentric rings with axis labels.
 *
 * @param {Object.<string, number>} data - Key-value pairs { "Label": value }
 * @param {string} [color=C.gold] - Polygon fill/stroke color
 * @param {number} [sz=220] - ViewBox size
 */
export const Radar = ({ data, color = C.gold, sz = 220 }) => {
  const cx = sz / 2, cy = sz / 2, r = sz * 0.36;
  const keys = Object.keys(data), n = keys.length;

  const pt = (i, v) => {
    const a = (Math.PI * 2 * i) / n - Math.PI / 2;
    return { x: cx + (v / 100) * r * Math.cos(a), y: cy + (v / 100) * r * Math.sin(a) };
  };

  return (
    <svg width="100%" viewBox={`0 0 ${sz} ${sz}`}>
      {/* Concentric rings */}
      {[25, 50, 75, 100].map(ring => (
        <polygon
          key={ring}
          points={keys.map((_, i) => pt(i, ring)).map(p => `${p.x},${p.y}`).join(' ')}
          fill="none" stroke={C.border} strokeWidth="0.3"
        />
      ))}

      {/* Axis lines */}
      {keys.map((_, i) => {
        const p = pt(i, 100);
        return <line key={i} x1={cx} y1={cy} x2={p.x} y2={p.y} stroke={C.border} strokeWidth="0.3" />;
      })}

      {/* Data polygon */}
      <polygon
        points={keys.map((k, i) => pt(i, data[k])).map(p => `${p.x},${p.y}`).join(' ')}
        fill={color + '18'} stroke={color} strokeWidth="1.2"
      />

      {/* Labels */}
      {keys.map((k, i) => {
        const p = pt(i, 115);
        return (
          <text key={k} x={p.x} y={p.y} textAnchor="middle" dominantBaseline="middle"
            fill={C.t2} fontSize="6.5" fontWeight="500">{k.toUpperCase()}</text>
        );
      })}

      {/* Data points */}
      {keys.map((k, i) => {
        const p = pt(i, data[k]);
        return <circle key={`c${i}`} cx={p.x} cy={p.y} r="2.5" fill={color} />;
      })}
    </svg>
  );
};
